import React from 'react';

import Pill from '@Components/Pill';
import { buildMessageKeyForEnum } from '@Config/messages';
import { AuctionAuctionType } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';
import { getPillTypeByAuctionType } from '@Utils/auction';

interface AuctionTypeDisplayProps {
  type: AuctionAuctionType;
  className?: string;
}

const AuctionTypeDisplay: React.FunctionComponent<AuctionTypeDisplayProps> = ({ type, className }) => {
  const t = useTranslations();

  return <Pill className={className} type={getPillTypeByAuctionType(type)} msg={t(buildMessageKeyForEnum(type))} />;
};

export default AuctionTypeDisplay;
